import EmptyStatesPreview from '../content/EmptyStatesPreview'
import {
  Artwork,
  LinkButton
} from '@eggplant/pattern-library'
import { HiPlus } from 'react-icons/hi'
import {
  LinkToAddTestConfig,
  useConfigTypeTitle,
  useModule
} from '@eggplant/routing'
import { LinkToTestConfigDoc } from '../links'
import { SpaceAccessControl } from '@eggplant/context'

const testDescription = `Test Configs are combinations of test cases and exploratory tests grouped in specific sequences to run against systems under test (SUTs).

📝 Start adding your test configurations now!`

const monitorDescription = `Monitor Configs are test cases tests grouped in specific sequences to run against systems under test (SUTs) regularly, which will provide a series of test results against time that you can check in monitor results and dashboard page.

📝 Start adding your monitor configurations now!`

const TestConfigIntro = () => {
  const [isMonitorFlag] = useModule()
  const configTypeTitle = useConfigTypeTitle(true)

  const typeBasedDescription = !isMonitorFlag
    ? testDescription
    : monitorDescription

  const typeBasedPath = !isMonitorFlag
    ? <Artwork.Path />
    : <Artwork.PageIcon />

  const renderButton = () =>
    <SpaceAccessControl isHiddenIfDenied>
      <LinkButton variant='primary'>
        <LinkToAddTestConfig>
          <HiPlus
            aria-hidden
            size='19.2px'
          /> New {configTypeTitle} Config
        </LinkToAddTestConfig>
      </LinkButton>
    </SpaceAccessControl>

  return (
    <div className='grid h-full justify-center'>
      <div className='grid w-[36em]'>
        <EmptyStatesPreview
          action={renderButton()}
          description={typeBasedDescription}
          icon={typeBasedPath}
          renderLink={<LinkToTestConfigDoc />}
          title={`${configTypeTitle} Configs`}
        />
      </div>
    </div>
  )
}

export default TestConfigIntro
